import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _9416efe0 = () => interopDefault(import('../src/pages/about-us.vue' /* webpackChunkName: "pages/about-us" */))
const _53ce9cf2 = () => interopDefault(import('../src/pages/authenticate.vue' /* webpackChunkName: "pages/authenticate" */))
const _05e1cee3 = () => interopDefault(import('../src/pages/big-spring-sale-2022.vue' /* webpackChunkName: "pages/big-spring-sale-2022" */))
const _e0831cca = () => interopDefault(import('../src/pages/black-friday-2021.vue' /* webpackChunkName: "pages/black-friday-2021" */))
const _e066edc8 = () => interopDefault(import('../src/pages/black-friday-2022.vue' /* webpackChunkName: "pages/black-friday-2022" */))
const _6edc9d57 = () => interopDefault(import('../src/pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _03de02f5 = () => interopDefault(import('../src/pages/business/index.vue' /* webpackChunkName: "pages/business/index" */))
const _c588fa90 = () => interopDefault(import('../src/pages/career-track-certificate.vue' /* webpackChunkName: "pages/career-track-certificate" */))
const _6b869790 = () => interopDefault(import('../src/pages/career-tracks/index.vue' /* webpackChunkName: "pages/career-tracks/index" */))
const _f9716a56 = () => interopDefault(import('../src/pages/certificate.vue' /* webpackChunkName: "pages/certificate" */))
const _47849478 = () => interopDefault(import('../src/pages/checkout.vue' /* webpackChunkName: "pages/checkout" */))
const _874f2cce = () => interopDefault(import('../src/pages/community-guidelines.vue' /* webpackChunkName: "pages/community-guidelines" */))
const _0dc3cd9d = () => interopDefault(import('../src/pages/contact-us.vue' /* webpackChunkName: "pages/contact-us" */))
const _6a640a17 = () => interopDefault(import('../src/pages/course-certificate.vue' /* webpackChunkName: "pages/course-certificate" */))
const _8132650e = () => interopDefault(import('../src/pages/courses/index.vue' /* webpackChunkName: "pages/courses/index" */))
const _62f82d64 = () => interopDefault(import('../src/pages/cyber-monday-2021.vue' /* webpackChunkName: "pages/cyber-monday-2021" */))
const _630644e5 = () => interopDefault(import('../src/pages/cyber-monday-2022.vue' /* webpackChunkName: "pages/cyber-monday-2022" */))
const _eace9778 = () => interopDefault(import('../src/pages/data-science-hero.vue' /* webpackChunkName: "pages/data-science-hero" */))
const _30f242d4 = () => interopDefault(import('../src/pages/faq.vue' /* webpackChunkName: "pages/faq" */))
const _c080e2dc = () => interopDefault(import('../src/pages/finance-courses-offer.vue' /* webpackChunkName: "pages/finance-courses-offer" */))
const _6e428fa0 = () => interopDefault(import('../src/pages/forgotten-password.vue' /* webpackChunkName: "pages/forgotten-password" */))
const _bd50e19a = () => interopDefault(import('../src/pages/free-data-science-month.vue' /* webpackChunkName: "pages/free-data-science-month" */))
const _7a513876 = () => interopDefault(import('../src/pages/free-days-2022.vue' /* webpackChunkName: "pages/free-days-2022" */))
const _7a350974 = () => interopDefault(import('../src/pages/free-days-2023.vue' /* webpackChunkName: "pages/free-days-2023" */))
const _feaef2ee = () => interopDefault(import('../src/pages/get-webinar-resources.vue' /* webpackChunkName: "pages/get-webinar-resources" */))
const _c4febb60 = () => interopDefault(import('../src/pages/got-what-it-takes.vue' /* webpackChunkName: "pages/got-what-it-takes" */))
const _b2505692 = () => interopDefault(import('../src/pages/instructors/index.vue' /* webpackChunkName: "pages/instructors/index" */))
const _3d0534ea = () => interopDefault(import('../src/pages/jumpstart-2023.vue' /* webpackChunkName: "pages/jumpstart-2023" */))
const _1c4cc0ed = () => interopDefault(import('../src/pages/live-trainings/index.vue' /* webpackChunkName: "pages/live-trainings/index" */))
const _3876d427 = () => interopDefault(import('../src/pages/login.vue' /* webpackChunkName: "pages/login" */))
const _0769de51 = () => interopDefault(import('../src/pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _0de85406 = () => interopDefault(import('../src/pages/most-wanted-offer.vue' /* webpackChunkName: "pages/most-wanted-offer" */))
const _5f0821b0 = () => interopDefault(import('../src/pages/one-of-two-hundred.vue' /* webpackChunkName: "pages/one-of-two-hundred" */))
const _12224f4d = () => interopDefault(import('../src/pages/password.vue' /* webpackChunkName: "pages/password" */))
const _4386fc84 = () => interopDefault(import('../src/pages/pricing.vue' /* webpackChunkName: "pages/pricing" */))
const _2a0f0926 = () => interopDefault(import('../src/pages/qa-hub/index.vue' /* webpackChunkName: "pages/qa-hub/index" */))
const _99f9f0ca = () => interopDefault(import('../src/pages/question/index.vue' /* webpackChunkName: "pages/question/index" */))
const _02a25313 = () => interopDefault(import('../src/pages/request-demo.vue' /* webpackChunkName: "pages/request-demo" */))
const _cf7c7790 = () => interopDefault(import('../src/pages/research-1001-data-scientists-2018-2020.vue' /* webpackChunkName: "pages/research-1001-data-scientists-2018-2020" */))
const _2aedd41c = () => interopDefault(import('../src/pages/resources-center/index.vue' /* webpackChunkName: "pages/resources-center/index" */))
const _18f26c40 = () => interopDefault(import('../src/pages/scholarship.vue' /* webpackChunkName: "pages/scholarship" */))
const _22bd9dca = () => interopDefault(import('../src/pages/signup.vue' /* webpackChunkName: "pages/signup" */))
const _583bf9f3 = () => interopDefault(import('../src/pages/sitemap.vue' /* webpackChunkName: "pages/sitemap" */))
const _c7e7ed56 = () => interopDefault(import('../src/pages/something-better.vue' /* webpackChunkName: "pages/something-better" */))
const _11fd664a = () => interopDefault(import('../src/pages/start-your-journey-for-free.vue' /* webpackChunkName: "pages/start-your-journey-for-free" */))
const _d40739ec = () => interopDefault(import('../src/pages/success-stories/index.vue' /* webpackChunkName: "pages/success-stories/index" */))
const _a999c950 = () => interopDefault(import('../src/pages/summer-sale-2022.vue' /* webpackChunkName: "pages/summer-sale-2022" */))
const _656d8e60 = () => interopDefault(import('../src/pages/support/index.vue' /* webpackChunkName: "pages/support/index" */))
const _e72498d2 = () => interopDefault(import('../src/pages/top-finance-training.vue' /* webpackChunkName: "pages/top-finance-training" */))
const _6a20d07c = () => interopDefault(import('../src/pages/upcoming-courses/index.vue' /* webpackChunkName: "pages/upcoming-courses/index" */))
const _48513675 = () => interopDefault(import('../src/pages/verify-certificate.vue' /* webpackChunkName: "pages/verify-certificate" */))
const _6c079d4c = () => interopDefault(import('../src/pages/warning.vue' /* webpackChunkName: "pages/warning" */))
const _c68a4fae = () => interopDefault(import('../src/pages/winter-special-offer-2022.vue' /* webpackChunkName: "pages/winter-special-offer-2022" */))
const _fc945da6 = () => interopDefault(import('../src/pages/you-missed-it.vue' /* webpackChunkName: "pages/you-missed-it" */))
const _f4630960 = () => interopDefault(import('../src/pages/blog/authors/index.vue' /* webpackChunkName: "pages/blog/authors/index" */))
const _2f890885 = () => interopDefault(import('../src/pages/business/signup.vue' /* webpackChunkName: "pages/business/signup" */))
const _24f2098d = () => interopDefault(import('../src/pages/live-trainings/signup.vue' /* webpackChunkName: "pages/live-trainings/signup" */))
const _e2db9b08 = () => interopDefault(import('../src/pages/resources-center/offer.vue' /* webpackChunkName: "pages/resources-center/offer" */))
const _125881b8 = () => interopDefault(import('../src/pages/resources-center/search.vue' /* webpackChunkName: "pages/resources-center/search" */))
const _f0c68acc = () => interopDefault(import('../src/pages/support/search.vue' /* webpackChunkName: "pages/support/search" */))
const _469df7e3 = () => interopDefault(import('../src/pages/resources-center/exams/signup.vue' /* webpackChunkName: "pages/resources-center/exams/signup" */))
const _225f23a8 = () => interopDefault(import('../src/pages/blog/authors/_author.vue' /* webpackChunkName: "pages/blog/authors/_author" */))
const _37acb840 = () => interopDefault(import('../src/pages/calculators/tables/_id.vue' /* webpackChunkName: "pages/calculators/tables/_id" */))
const _dac3f17c = () => interopDefault(import('../src/pages/resources-center/exams/_id/index.vue' /* webpackChunkName: "pages/resources-center/exams/_id/index" */))
const _d2e9c844 = () => interopDefault(import('../src/pages/resources-center/exams/_id/finalize.vue' /* webpackChunkName: "pages/resources-center/exams/_id/finalize" */))
const _82cb1436 = () => interopDefault(import('../src/pages/resources-center/exams/_id/instructions.vue' /* webpackChunkName: "pages/resources-center/exams/_id/instructions" */))
const _43d9106c = () => interopDefault(import('../src/pages/calculators/_name.vue' /* webpackChunkName: "pages/calculators/_name" */))
const _2632a8d6 = () => interopDefault(import('../src/pages/career-tracks/_track.vue' /* webpackChunkName: "pages/career-tracks/_track" */))
const _451f8621 = () => interopDefault(import('../src/pages/courses/_course.vue' /* webpackChunkName: "pages/courses/_course" */))
const _8174c13e = () => interopDefault(import('../src/pages/instructors/_instructor.vue' /* webpackChunkName: "pages/instructors/_instructor" */))
const _1a961fa5 = () => interopDefault(import('../src/pages/live-trainings/_slug.vue' /* webpackChunkName: "pages/live-trainings/_slug" */))
const _0f828a31 = () => interopDefault(import('../src/pages/preview/_id.vue' /* webpackChunkName: "pages/preview/_id" */))
const _75e85228 = () => interopDefault(import('../src/pages/qa-hub/_article.vue' /* webpackChunkName: "pages/qa-hub/_article" */))
const _56b9da0e = () => interopDefault(import('../src/pages/question/_question.vue' /* webpackChunkName: "pages/question/_question" */))
const _a3492280 = () => interopDefault(import('../src/pages/resources-center/_category/index.vue' /* webpackChunkName: "pages/resources-center/_category/index" */))
const _16a29b9e = () => interopDefault(import('../src/pages/special-offer/_id.vue' /* webpackChunkName: "pages/special-offer/_id" */))
const _167b9ff2 = () => interopDefault(import('../src/pages/success-stories/_id.vue' /* webpackChunkName: "pages/success-stories/_id" */))
const _0721a190 = () => interopDefault(import('../src/pages/support/_id.vue' /* webpackChunkName: "pages/support/_id" */))
const _a6b66510 = () => interopDefault(import('../src/pages/resources-center/_category/_slug.vue' /* webpackChunkName: "pages/resources-center/_category/_slug" */))
const _6ecf3110 = () => interopDefault(import('../src/pages/index.vue' /* webpackChunkName: "pages/index" */))
const _2ad1ab57 = () => interopDefault(import('../src/pages/_blogCategory/_blogSubItem/index.vue' /* webpackChunkName: "pages/_blogCategory/_blogSubItem/index" */))
const _3fe12bc0 = () => interopDefault(import('../src/pages/_blogCategory/_blogSubItem/_blogArticle.vue' /* webpackChunkName: "pages/_blogCategory/_blogSubItem/_blogArticle" */))
const _957e85c6 = () => interopDefault(import('../src/pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about-us",
    component: _9416efe0,
    name: "about-us"
  }, {
    path: "/authenticate",
    component: _53ce9cf2,
    name: "authenticate"
  }, {
    path: "/big-spring-sale-2022",
    component: _05e1cee3,
    name: "big-spring-sale-2022"
  }, {
    path: "/black-friday-2021",
    component: _e0831cca,
    name: "black-friday-2021"
  }, {
    path: "/black-friday-2022",
    component: _e066edc8,
    name: "black-friday-2022"
  }, {
    path: "/blog",
    component: _6edc9d57,
    name: "blog"
  }, {
    path: "/business",
    component: _03de02f5,
    name: "business"
  }, {
    path: "/career-track-certificate",
    component: _c588fa90,
    name: "career-track-certificate"
  }, {
    path: "/career-tracks",
    component: _6b869790,
    name: "career-tracks"
  }, {
    path: "/certificate",
    component: _f9716a56,
    name: "certificate"
  }, {
    path: "/checkout",
    component: _47849478,
    name: "checkout"
  }, {
    path: "/community-guidelines",
    component: _874f2cce,
    name: "community-guidelines"
  }, {
    path: "/contact-us",
    component: _0dc3cd9d,
    name: "contact-us"
  }, {
    path: "/course-certificate",
    component: _6a640a17,
    name: "course-certificate"
  }, {
    path: "/courses",
    component: _8132650e,
    name: "courses"
  }, {
    path: "/cyber-monday-2021",
    component: _62f82d64,
    name: "cyber-monday-2021"
  }, {
    path: "/cyber-monday-2022",
    component: _630644e5,
    name: "cyber-monday-2022"
  }, {
    path: "/data-science-hero",
    component: _eace9778,
    name: "data-science-hero"
  }, {
    path: "/faq",
    component: _30f242d4,
    name: "faq"
  }, {
    path: "/finance-courses-offer",
    component: _c080e2dc,
    name: "finance-courses-offer"
  }, {
    path: "/forgotten-password",
    component: _6e428fa0,
    name: "forgotten-password"
  }, {
    path: "/free-data-science-month",
    component: _bd50e19a,
    name: "free-data-science-month"
  }, {
    path: "/free-days-2022",
    component: _7a513876,
    name: "free-days-2022"
  }, {
    path: "/free-days-2023",
    component: _7a350974,
    name: "free-days-2023"
  }, {
    path: "/get-webinar-resources",
    component: _feaef2ee,
    name: "get-webinar-resources"
  }, {
    path: "/got-what-it-takes",
    component: _c4febb60,
    name: "got-what-it-takes"
  }, {
    path: "/instructors",
    component: _b2505692,
    name: "instructors"
  }, {
    path: "/jumpstart-2023",
    component: _3d0534ea,
    name: "jumpstart-2023"
  }, {
    path: "/live-trainings",
    component: _1c4cc0ed,
    name: "live-trainings"
  }, {
    path: "/login",
    component: _3876d427,
    name: "login"
  }, {
    path: "/maintenance",
    component: _0769de51,
    name: "maintenance"
  }, {
    path: "/most-wanted-offer",
    component: _0de85406,
    name: "most-wanted-offer"
  }, {
    path: "/one-of-two-hundred",
    component: _5f0821b0,
    name: "one-of-two-hundred"
  }, {
    path: "/password",
    component: _12224f4d,
    name: "password"
  }, {
    path: "/pricing",
    component: _4386fc84,
    name: "pricing"
  }, {
    path: "/qa-hub",
    component: _2a0f0926,
    name: "qa-hub"
  }, {
    path: "/question",
    component: _99f9f0ca,
    name: "question"
  }, {
    path: "/request-demo",
    component: _02a25313,
    name: "request-demo"
  }, {
    path: "/research-1001-data-scientists-2018-2020",
    component: _cf7c7790,
    name: "research-1001-data-scientists-2018-2020"
  }, {
    path: "/resources-center",
    component: _2aedd41c,
    name: "resources-center"
  }, {
    path: "/scholarship",
    component: _18f26c40,
    name: "scholarship"
  }, {
    path: "/signup",
    component: _22bd9dca,
    name: "signup"
  }, {
    path: "/sitemap",
    component: _583bf9f3,
    name: "sitemap"
  }, {
    path: "/something-better",
    component: _c7e7ed56,
    name: "something-better"
  }, {
    path: "/start-your-journey-for-free",
    component: _11fd664a,
    name: "start-your-journey-for-free"
  }, {
    path: "/success-stories",
    component: _d40739ec,
    name: "success-stories"
  }, {
    path: "/summer-sale-2022",
    component: _a999c950,
    name: "summer-sale-2022"
  }, {
    path: "/support",
    component: _656d8e60,
    name: "support"
  }, {
    path: "/top-finance-training",
    component: _e72498d2,
    name: "top-finance-training"
  }, {
    path: "/upcoming-courses",
    component: _6a20d07c,
    name: "upcoming-courses"
  }, {
    path: "/verify-certificate",
    component: _48513675,
    name: "verify-certificate"
  }, {
    path: "/warning",
    component: _6c079d4c,
    name: "warning"
  }, {
    path: "/winter-special-offer-2022",
    component: _c68a4fae,
    name: "winter-special-offer-2022"
  }, {
    path: "/you-missed-it",
    component: _fc945da6,
    name: "you-missed-it"
  }, {
    path: "/blog/authors",
    component: _f4630960,
    name: "blog-authors"
  }, {
    path: "/business/signup",
    component: _2f890885,
    name: "business-signup"
  }, {
    path: "/live-trainings/signup",
    component: _24f2098d,
    name: "live-trainings-signup"
  }, {
    path: "/resources-center/offer",
    component: _e2db9b08,
    name: "resources-center-offer"
  }, {
    path: "/resources-center/search",
    component: _125881b8,
    name: "resources-center-search"
  }, {
    path: "/support/search",
    component: _f0c68acc,
    name: "support-search"
  }, {
    path: "/resources-center/exams/signup",
    component: _469df7e3,
    name: "resources-center-exams-signup"
  }, {
    path: "/blog/authors/:author",
    component: _225f23a8,
    name: "blog-authors-author"
  }, {
    path: "/calculators/tables/:id?",
    component: _37acb840,
    name: "calculators-tables-id"
  }, {
    path: "/resources-center/exams/:id",
    component: _dac3f17c,
    name: "resources-center-exams-id"
  }, {
    path: "/resources-center/exams/:id/finalize",
    component: _d2e9c844,
    name: "resources-center-exams-id-finalize"
  }, {
    path: "/resources-center/exams/:id/instructions",
    component: _82cb1436,
    name: "resources-center-exams-id-instructions"
  }, {
    path: "/calculators/:name?",
    component: _43d9106c,
    name: "calculators-name"
  }, {
    path: "/career-tracks/:track?",
    component: _2632a8d6,
    name: "career-tracks-track"
  }, {
    path: "/courses/:course",
    component: _451f8621,
    name: "courses-course"
  }, {
    path: "/instructors/:instructor",
    component: _8174c13e,
    name: "instructors-instructor"
  }, {
    path: "/live-trainings/:slug?",
    component: _1a961fa5,
    name: "live-trainings-slug"
  }, {
    path: "/preview/:id?",
    component: _0f828a31,
    name: "preview-id"
  }, {
    path: "/qa-hub/:article?",
    component: _75e85228,
    name: "qa-hub-article"
  }, {
    path: "/question/:question",
    component: _56b9da0e,
    name: "question-question"
  }, {
    path: "/resources-center/:category",
    component: _a3492280,
    name: "resources-center-category"
  }, {
    path: "/special-offer/:id?",
    component: _16a29b9e,
    name: "special-offer-id"
  }, {
    path: "/success-stories/:id?",
    component: _167b9ff2,
    name: "success-stories-id"
  }, {
    path: "/support/:id",
    component: _0721a190,
    name: "support-id"
  }, {
    path: "/resources-center/:category?/:slug",
    component: _a6b66510,
    name: "resources-center-category-slug"
  }, {
    path: "/",
    component: _6ecf3110,
    name: "index"
  }, {
    path: "/:blogCategory/:blogSubItem",
    component: _2ad1ab57,
    name: "blogCategory-blogSubItem"
  }, {
    path: "/:blogCategory/:blogSubItem?/:blogArticle",
    component: _3fe12bc0,
    name: "blogCategory-blogSubItem-blogArticle"
  }, {
    path: "/*",
    component: _957e85c6,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
